<template>
  <div>
    <div class="container-fluid">
      <div class="card-body p-4">
        <div class="table-responsive w-100 mt-2">
          <h3 style="display: inline; margin-right: 15px">Categorías</h3>
          <AddCategory @refresh="getCategories" />

          <div class="card-body">
            <div v-if="loading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
              <div class="mt-2 text-muted">Cargando categorías...</div>
            </div>

            <table v-else class="table table-bordered settings-table mt-3">
              <thead>
                <tr class="bg-dark text-white">
                  <th class="col-drag text-center">
                    <i class="fas fa-arrows-alt-v"></i>
                  </th>
                  <th class="col-pos text-center">Pos.</th>
                  <th class="col-title">Título</th>
                  <th class="col-topic">Temática</th>
                  <th class="col-status text-center">Estado</th>
                  <th class="col-actions text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <CategoryRow 
                  v-for="(item, index) in categories" 
                  :key="item.UUID" 
                  :category="item"
                  :position="index + 1"
                  @refresh="getCategories"
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddCategory from "@/components/Blog/elements/Categories/AddCategory.vue";
import CategoryRow from "@/components/Blog/elements/Categories/CategoryRow.vue";
import CategoryService from "@/services/category.service.js";

export default {
  name: "ForumCategories",
  components: {
    AddCategory,
    CategoryRow,
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      categories: [],
      loading: true,
    };
  },
  methods: {
    async getCategories() {
      this.loading = true;
      try {
        const response = await CategoryService.getAllCategories();
        this.categories = response.data.items ? response.data.items : response.data;
      } catch (error) {
        console.error("Error loading categories:", error);
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getCategories();
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.settings-table {
  table-layout: fixed;
  width: 100%;
}

/* Drag handle and Position columns should be tight */
.col-drag {
  width: 40px;
}
.col-pos {
  width: 50px;
  text-align: center;
}

/* Main content columns */
.col-title {
  width: auto;
}
.col-topic {
  width: 25%;
}

/* Status and Actions */
.col-status {
  width: 85px;
}
.col-actions {
  width: 95px;
}

th {
  font-size: 0.85rem;
  vertical-align: middle;
}

/* Ensure child component cells handle overflow nicely */
:deep(td) {
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>